import { validDate } from './parsers'
import _ from 'underscore'

const conditionalChecks = [
  // # ‘The following checks that LimitType is 'NA' when missing Limits
  [
    '//DetectionLimit[. =""]',
    'DetectionLimitType[. ="NA"]',
    "DetectionLimitType must be 'NA' when DetectionLimit is null"
  ],

  [
    '//ReportingLimit[. =""]',
    'ReportingLimitType[. = "NA"]',
    "ReportingLimitType must be 'NA' when ReportingLimit is null"
  ],

  [
    '//QuantitationLimit[. =""]',
    'QuantitationLimitType[. = "NA"]',
    "QuantitationLimitType must be 'NA' when QuantitationLimit is null"
  ],
  
  // 'The following checks that LimitUnits are also 'NA' when missing Limits
  [
    '//DetectionLimitType[. ="NA"]',
    'DetectionLimitUnits[. ="NA"]',
    "DetectionLimitUnits must be 'NA' when DetectionLimitType is 'NA'"
  ],
  [
    '//ReportingLimitType[. ="NA"]',
    'ReportingLimitUnits[. ="NA"]',
    "ReportingLimitUnits must be 'NA' when ReportingLimitType is 'NA'"
  ],
  [
    '//QuantitationLimitType[. ="NA"]',
    'QuantitationLimitUnits[. ="NA"]',
    "QuantitationLimitUnits must be 'NA' when QuantitationLimitType is 'NA'"
  ],

  // 'The following checks that units are listed if limits are populated
  [
    '//DetectionLimit[. !=""]',
    'DetectionLimitUnits[. !=""]',
    "DetectionLimitUnits cannot be null when DetectionLimit is populated'"
  ],
  [
    '//QuantitationLimit[. !=""]',
    'QuantitationLimitUnits[. !=""]',
    "QuantitationLimitUnits cannot be null when QuantitationLimit is populated'"
  ],
  [
    '//ReportingLimit[. !=""]',
    'ReportingLimitUnits[. !=""]',
    "ReportingLimitUnits cannot be null when ReportingLimit is populated'"
  ],

  // 'The following checks that LimitType are listed if limits are populated
  [
    '//DetectionLimit[. !=""]',
    'DetectionLimitType[. !=""]',
    "DetectionLimitType cannot be null when DetectionLimit is populated'"
  ],
  [
    '//QuantitationLimit[. !=""]',
    'QuantitationLimitType[. !=""]',
    "QuantitationLimitType cannot be null when QuantitationLimit is populated'"
  ],
  [
    '//ReportingLimit[. !=""]',
    'ReportingLimitType[. !=""]',
    "ReportingLimitType cannot be null when ReportingLimit is populated'"
  ],
  // 'ExpectedResult and ExpectedResultUnits must be populated when AnalyteType is Surrogate, Spike, System_Monitoring_Compound, Internal_Standard
  [
    '//AnalyteType[. ="Surrogate" or . = "Spike"]',
    'ExpectedResult[. !=""]',
    'ExpectedResult must be specified when AnalyteType is Surrogate, Spike, System_Monitoring_Compound, Internal_Standard'
  ],
  [
    '//AnalyteType[. ="Surrogate" or . = "Spike" or . = "System_Monitoring_Compound" or . ="Internal_Standard"]',
    'ExpectedResultUnits[. !=""]',
    'ExpectedResultUnits must be specified when AnalyteType is Surrogate, Spike, System_Monitoring_Compound, Internal_Standard'
  ],

  // 'PercentRecovery, PercentRecoverLimitHigh, PercentRecoverLimitLow, PercentRecoverLimitType must be populated when AnalyteType is Surrogate, Spike'
  [
    '//AnalyteType[. ="Surrogate" or . = "Spike"]',
    'PercentRecovery[. !=""]',
    'PercentRecovery must be populated when AnalyteType is Surrogate, Spike'
  ],
  [
    '//AnalyteType[. ="Surrogate" or . = "Spike"]',
    'PercentRecoveryLimitHigh[. !=""]',
    'PercentRecoverLimitHigh must be populated when AnalyteType is Surrogate, Spike'
  ],
  [
    '//AnalyteType[. ="Surrogate" or . = "Spike"]',
    'PercentRecoveryLimitLow[. !=""]',
    'PercentRecoveryLimitLow must be populated when AnalyteType is Surrogate, Spike'
  ],
  [
    '//AnalyteType[. ="Surrogate" or . = "Spike"]',
    'PercentRecoveryLimitType[. !=""]',
    'PercentRecoveryLimitType must be populated when AnalyteType is Surrogate, Spike'
  ],

  // 'CollectedDate must be populated when QCType = Field_Sample
  [
    '//QCType[. = "Field_Sample"]',
    'CollectedDate[. !=""]',
    'CollectedDate must be populated when QCType is Field_Sample'
  ],


  [
    '//AnalyteType[.="Target" and ../CASRegistryNumber !="PCT_Solids" and ../CASRegistryNumber !="PCT_MOISTURE"]',
    'DetectionLimit[. !=""]',
    'DetectionLimit should be populated when AnalyteType is Target',
    'warning'
  ],

  [
    '//ResultType[.="Not_Detected" and ../CASRegistryNumber !="PCT_Solids" and ../CASRegistryNumber !="PCT_MOISTURE"]',
    'DetectionLimit[. !=""]',
    'DetectionLimit must be populated when ResultType is Not_Detected'
  ],

  [
    '//AnalyteType[.="Target" and ../CASRegistryNumber !="PCT_Solids" and ../CASRegistryNumber !="PCT_MOISTURE"]',
    'ReportingLimit[. !=""]',
    'ReportingLimit should be populated when AnalyteType is Target',
    'warning'
  ],

  [
    '//ResultType[.="Not_Detected" and ../CASRegistryNumber !="PCT_Solids" and ../CASRegistryNumber !="PCT_MOISTURE"]',
    'ReportingLimit[. !=""]',
    'ReportingLimit must be populated when ResultType is Not_Detected'
  ],

  [
    '//AnalyteType[.="Target" and ../CASRegistryNumber !="PCT_Solids" and ../CASRegistryNumber !="PCT_MOISTURE"]',
    'QuantitationLimit[. !=""]',
    'QuantitationLimit should be populated when AnalyteType is Target',
    'warning'
  ],

  [
    '//ResultType[.="Not_Detected" and ../CASRegistryNumber !="PCT_Solids" and ../CASRegistryNumber !="PCT_MOISTURE"]',
    'QuantitationLimit[. !=""]',
    'QuantitationLimit must be populated when ResultType is Not_Detected'
  ],

  // 'LabReceiptDate is not blank when QCType = Field_Sample
  [
    '//QCType[. = "Field_Sample"]',
    'LabReceiptDate[. !=""]',
    'LabReceiptDate must be populated when QCType is Field_Sample'
  ],

  // 'OriginalClientSampleID must be populated when QCType = Matrix_Spike, Matrix_Spike_Duplicate
  [
    '//QCType[. = "Matrix_Spike" or . = "Matrix_Spike_Duplicate"]',
    'OriginalClientSampleID[. !=""]',
    'OriginalClientSampleID must be populated when QCType is Matrix_Spike, Matrix_Spike_Duplicate'
  ],

  //  'OriginalLabSampleID must be populated when QCType = Duplicate, Matrix_Spike_Duplicate
  [
    '//QCType[. = "Duplicate" or . = "Matrix_Spike_Duplicate"]',
    'OriginalLabSampleID[. !=""]',
    'OriginalLabSampleID must be populated when QCType is Duplicate, Matrix_Spike_Duplicate'
  ],

  // 'Result must be populated if ResultType is '='
  ['//ResultType[. = "="]',
   'Result[. !=""]', 
   "Result must be populated if ResultType is '='"],

  // Result must be blank if ResultType is "Not_Detected
  [
    '//ResultType[. = "Not_Detected"]',
    'Result[. =""]',
    'Result must be null if ResultType is "Not_Detected"'
  ],

  // 'ResultUnits must not be blank when Result is not blank'
  [
    '//Result[. != ""]',
    'ResultUnits[. != ""]',
    'ResultUnits must be populated when Result is not null'
  ],

  // 'RPD, RPDLimitHigh must be populated when SPM.QCType = DUP, MSD, LCSD
  [
    '//QCType[. = "Duplicate" or . = "Matrix_Spike_Duplicate" or . = "Laboratory_Control_Sample_Duplicate"]',
    'ReportedResult/RPD[. != ""]',
    'RPD must be populated when QCType is Duplicate, Matrix_Spike_Duplicate, Laboratory_Control_Sample_Duplicate'
  ],
  [
    '//QCType[. = "Duplicate" or . = "Matrix_Spike_Duplicate" or . = "Laboratory_Control_Sample_Duplicate"]',
    'ReportedResult/RPDLimitHigh[. != ""]',
    'RPDLimitHigh must be populated when QCType is Duplicate, Matrix_Spike_Duplicate, Laboratory_Control_Sample_Duplicate'
  ],

  // PercentRecoveryLimitLow and PercentRecoveryLimitHigh must be populated if PercentRecovery is not null
  [
    '//PercentRecovery[. !=""]',
    'PercentRecoveryLimitLow[. !=""]',
    'PercentRecoveryLimitLow must be populated when PercentRecovery is reported'
  ],
  [
    '//PercentRecovery[. !=""]',
    'PercentRecoveryLimitHigh[. !=""]',
    'PercentRecoveryLimitHigh must be populated when PercentRecovery is reported'
  ],

  // Check that PreparationBatch is populated if PPC node exists
  [
    '//PreparationPlusCleanup[. !=""]',
    'PreparationBatch[. !=""]',
    'Analysis.PreparationBatch must be populated when PreparationPlusCleanup node is used'
  ],

  [
    '//QCType[. ="Cleanup_Blank" or .="Duplicate" or .= "Laboratory_Control_Sample" or .="Laboratory_Control_Sample_Duplicate" or .="Laboratory_Fortified_Blank" or .= "Laboratory_Fortified_Blank_Duplicate" or .= "Matrix_Spike" or .= "Matrix_Spike_Duplicate" or .= "Method_Blank" or .="Post_Digestion_Spike"]',
    'QCCategory[. !=""]',
    'QCCategory required if QCType is not Field_Sample'
  ],
  [
    '//QCType[. ="Cleanup_Blank" or .="Duplicate" or .= "Laboratory_Control_Sample" or .="Laboratory_Control_Sample_Duplicate" or .="Laboratory_Fortified_Blank" or .= "Laboratory_Fortified_Blank_Duplicate" or .= "Matrix_Spike" or .= "Matrix_Spike_Duplicate" or .= "Method_Blank" or .="Post_Digestion_Spike"]',
    'QCLinkage[. !=""]',
    'QCLinkage required if QCType is not Field_Sample'
  ],

  // ResultBasis required if MatrixMedium = 'Solid'
  [
    '//MatrixMedium[. ="Solid"]',
    'Analysis/ResultBasis[. !=""]',
    'ResultBasis must be populated when MatrixMedium is Solid'
  ],

  [
    '//QCType[. = "Matrix_Spike" or . = "Matrix_Spike_Duplicate"]',
    'OriginalClientSampleID[. !=""]',
    'OriginalClientSampleID must be populated when QCType is Matrix_Spike, Matrix_Spike_Duplicate (can use dummy ID for non-project parent samples)'
  ],
  [
    '//QCType[. = "Matrix_Spike" or . = "Matrix_Spike_Duplicate"]',
    'OriginalLabSampleID[. !=""]',
    'OriginalLabSampleID must be populated when QCType is Matrix_Spike, Matrix_Spike_Duplicate'
  ],

  // Checking for issues with 'U' lab flags (which should never be needed, but labs sometimes use)
  [
    '//ReportedResult/ResultType[.="Not_Detected"]',
    'LabQualifiers[not(contains(text(), "U"))]',
    'Redundant flag. U flag should not be used when result type is "Not_Detected"',
    'warning'
  ],

  [
    '//ReportedResult/ResultType[.="="]',
    'LabQualifiers[not(contains(text(), "U"))]',
    'Conflicting flag. U lab flag should never be used when result type is "="',
  ],

  // checks for surrogate data in ReportedResults node - NOT WORKING
  // [
  //   '//ReportedResults[. !=""]',
  //   '../AnalyteType[. !="Surrogate"]',
  //   'Warning: Surrogates should be reported in the Analytes node, not in ReportedResults'
  // ],

  // ResultBasis must be 'Leachate' if medium is Solid and Units end in '/L' indicating an aqueous result
  [
    '//MatrixMedium[. ="Solid" and ../ReportingLimitUnits[contains(text(), "/L")]]',
    'ReportedResults/ResultBasis[. !="Leachate"]',
    "ResultBasis must be 'Leachate' when MatrixMedium is 'Solid' and units indicate an Aqueous result"
  ]

]

const validNumber = string => {
  return /^[-+]?[0-9]*\.?[0-9]+$/.test(string)
}

export default function validate(xmlDoc, rawXml, requiredFields, validFields, cb) {
  const errors = []
  const warnings = []

  const xPath = (selector, doc = xmlDoc) =>
    xmlDoc.evaluate(selector, doc, null, XPathResult.ANY_TYPE, null)

  setTimeout(() => {
    conditionalChecks.forEach(([sel1, sel2, error, level = 'error', debug = false]) => {
      if (debug) debugger
      const iterator = xPath(sel1)
      let node = iterator.iterateNext()
      while (node) {
        const result = xPath(sel2, node.parentElement).iterateNext()
        if (!result) {
          if (level === 'error') {
            errors.push({
              message: error,
              element: node.parentElement
            })
          } else if (level === 'warning') {
            warnings.push({
              message: error,
              element: node.parentElement
            })
          }
        }
        node = iterator.iterateNext()
      }
    })

    const dateFormat = xPath('//Header/DateFormat')
      .iterateNext()
      .textContent.replace(/\.sTZD$/, '')

    requiredFields.forEach(({ field, data_type, node, cd_reqd }) => {
      const iterator = xPath(`//${node}`)
      let xmlNode = iterator.iterateNext()
      while (xmlNode) {
        const result = xPath(`${field}[. =""]`, xmlNode).iterateNext()
        if (result) {
          if (cd_reqd) {
            errors.push({
              message: `Missing required field ${field} for ${node}`,
              element: xmlNode
            })
          }
        } else {
          const textNode = xPath(field, xmlNode).iterateNext()
          if (!textNode) {
            if (cd_reqd) {
              errors.push({
                message: `Missing required field ${field} for ${node}`,
                element: xmlNode
              })
            }
            xmlNode = iterator.iterateNext()
            continue
          }
          let text = textNode.textContent
          if (data_type === 'double precision') {
            if (validNumber(text)) {
              //nothing
            } else if (validNumber(text.trim())) {
              warnings.push({
                message: `Unnecessary spaces around number ${xmlNode.tagName}:${field}`,
                element: xmlNode
              })
            } else {
              errors.push({
                message: `Unparsable number "${text}" ${xmlNode.tagName}:${field}`,
                element: xmlNode
              })
            }
          }
          if (data_type === 'timestamp without time zone') {
            if (validDate(text, dateFormat)) {
              //nothing
            } else if (validDate(text.trim(), dateFormat)) {
              warnings.push({
                message: `Unnecessary spaces around date "${text}" ${xmlNode.tagName}:${field}`,
                element: xmlNode
              })
            } else {
              errors.push({
                message: `Cannot parse date ${text} with format ${dateFormat}`,
                element: xmlNode
              })
            }
          }
        }
        //varchar is always valid
        xmlNode = iterator.iterateNext()
      }
    })

    const restrictedFields = validFields.reduce((restricted, pair) => {
      restricted[pair['field']] = restricted[pair['field']] || []
      restricted[pair['field']].push(pair['vvl'])
      return restricted
    }, {})

    const valid = {}
    validFields.forEach(({ field, vvl }) => {
      valid[field + '.' + vvl] = 1
    })

    const eddVersion = xPath('//Header/EDDVersion').iterateNext().textContent
    if (eddVersion !== '5.2') {
      errors.push({
        message: 'Invalid EDD Version, expected 5.2',
        element: xPath('//Header').iterateNext()
      })
    }

    _.map(restrictedFields, (validValues, restrictedField) => {
      const iterator = xPath(`//${restrictedField}`)
      let xmlNode = iterator.iterateNext()
      while (xmlNode) {
        let text = xmlNode.textContent
        if (!text) {
          xmlNode = iterator.iterateNext()
          continue
        }
        if (!valid[`${restrictedField}.${text}`]) {
          errors.push({
            message: `Invalid value "${text}" for field ${restrictedField}. Valid values may be downloaded using the link below.`,
            element: xmlNode
          })
        }
        xmlNode = iterator.iterateNext()
      }
    })

    return cb({ errors, warnings, validated: true })
  }, 100)
}
